import DatePicker from '@components/_Layout/Controls/DatePicker';
import DateRangePicker from '@components/_Layout/Controls/DateRangePicker';
import PropTypes from 'prop-types';
import React from 'react';
import { ReactDatePickerProps } from 'react-datepicker';
import { useConfig } from '@hooks';

interface SearchDateProps extends ReactDatePickerProps {
  inputType?: "datepicker" | "daterangepicker"
  additionalClassname?: string,
};

const SearchDate: React.FC<SearchDateProps> = ({ inputType = "datepicker", additionalClassname, ...props }) => {
  const { mode: clientMode } = useConfig();
  const mode = clientMode ? clientMode : "vacanceole";

  const themedClassname = `tw-w-full tw-rounded-full tw-border tw-outline-none tw-py-1 tw-px-4 tw-leading-8 tw-bg-white tw-font-montserrat tw-transition-colors tw-duration-200 tw-ease-in-out ${
    mode === "vacanceole"
      ? "tw-border-v_blue-dark tw-text-v_blue-dark focus:tw-border-v_blue-dark"
      : "tw-border-primary_corseole-500 tw-text-primary_corseole-500 focus:tw-border-primary_corseole-500"
  } ${additionalClassname ?? ""}`;

  const dayClassName = () =>
    mode === "vacanceole"
      ? "search-datepicker-day-vacanceole"
      : "search-datepicker-day-corseole";

  let result: JSX.Element;
  switch (inputType) {
    case "datepicker":
      result = <>
        <DatePicker dayClassName={dayClassName} className={themedClassname} name="search_dp" {...props} />
      </>
      break;
    case "daterangepicker":
      result = <>
        <DateRangePicker dayClassName={dayClassName} className={themedClassname} name="search_drp" {...props} />
      </>
      break;

    default:
      result = <>
        <DatePicker dayClassName={dayClassName} className={themedClassname} name="search_dp" {...props} />
      </>
      break;
  };

  return (
    result
  )
}

SearchDate.propTypes = {
  inputType: PropTypes.oneOf(["datepicker", "daterangepicker"]),
  additionalClassname: PropTypes.string
};

export default SearchDate;
